import CybersecurityHero from './CybersecurityHero';
import CybersecurityHighlights from './CybersecurityHighlights';
import CybersecurityServiceTabs from './CybersecurityServiceTabs';
import TitleUpdater from '../../../../../utils/TitleUpdater';
import CybersecurityTechnologyStacks from './CybersecurityTechnologyStacks';
import CybersecurityFaqs from './CybersecurityFaqs';

const colors = {
  text: '#28384A',
};

export default function CybersecurityServices() {
  return (<main className="cybersecurity-page bg-white" style={{ color: colors.text, overflow: 'hidden' }}>
    <style>{`.cybersecurity-page, .cybersecurity-page * { font-family: 'Be Vietnam Pro', sans-serif; }
      .cybersecurity-page p { text-align: left; hyphens: none; word-spacing: normal; }
      .cybersecurity-page .cyber-centered p { text-align: center; }`}</style>
    <TitleUpdater title="Cybersecurity Services" />

    <CybersecurityHero />
    <CybersecurityServiceTabs />
    <CybersecurityHighlights />

    <CybersecurityTechnologyStacks />

    <CybersecurityFaqs />
  </main>);
}
